"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var isDateString = function isDateString(string) {
  return !Number.isNaN(Date.parse(string));
};

var DateConverter = /*#__PURE__*/function () {
  function DateConverter() {
    _classCallCheck(this, DateConverter);
  }

  _createClass(DateConverter, [{
    key: "canConvertToCustomFormat",
    value: function canConvertToCustomFormat(obj) {
      return obj instanceof Date;
    }
  }, {
    key: "convertToCustomFormat",
    value: function convertToCustomFormat(date) {
      return {
        $date: date.toISOString()
      };
    }
  }, {
    key: "canConvertFromCustomFormat",
    value: function canConvertFromCustomFormat(obj) {
      return obj && _typeof(obj) === "object" && "$date" in obj && isDateString(obj.$date);
    }
  }, {
    key: "convertFromCustomFormat",
    value: function convertFromCustomFormat(obj) {
      return new Date(obj.$date);
    }
  }]);

  return DateConverter;
}();

module.exports = {
  DateConverter: DateConverter
};